<template>
  <dialogWrap
    v-model="visible"
    title="转移申请信息采集"
    width="800px"
    @close="handleClose"
    :close-on-click-modal="false"
    z-index="1000"
  >
    <div class="transfer-dialog-content" ref="dialogContentRef">
      <div class="upload-section">
        <el-row :gutter="60" type="flex" justify="center">
          <el-col :span="10" class="upload-col">
            <div class="upload-wrapper">
              <div class="upload-title-red">必选</div>
              <div class="upload-card" ref="writtenApplicationCardRef">
                <el-upload
                    v-show="writtenApplicationFiles.length === 0"
                    class="custom-uploader"
                    :action="actionUrl"
                    :headers="uploadHeaders"
                    :data="{ group: 'order', code: 'order_contract_attachment_file' }"
                    :show-file-list="false"
                    accept="image/jpeg,.jpg,.jpeg"
                    :before-upload="beforeImageUpload"
                    :on-success="handleWrittenApplicationSuccess"
                    :on-error="handleUploadError"
                  >
                    <div class="upload-placeholder">
                        <i class="el-icon-picture-outline"></i>
                        <i class="el-icon-plus plus-icon"></i>
                        <span>点击添加本地文件</span>
                    </div>
                  </el-upload>

                <div class="upload-preview" v-if="writtenApplicationFiles.length > 0">
                  <img :src="writtenApplicationFiles[0].url" class="preview-image" />
                  <div class="card-actions">
                      <span class="action-btn" @click="previewImage(writtenApplicationFiles[0].url)">预览</span>
                      <span class="action-btn" @click="handleWrittenApplicationRemove(0)">移除</span>
                  </div>
                </div>
              </div>
              <div class="upload-label">
                书面申请(JPG/JPEG)
                <el-tooltip class="item" effect="dark" placement="top">
                  <div slot="content">
                    1、自持或代持系统会自动判断调整书面申请书的内容.<br/>
                    2、有电子签章时,可以选择电子签章,自动上传.  无电子签章,可以下载书面申请(内容已经填写好),盖章后上传.
                  </div>
                  <i class="el-icon-question" style="color: #999; margin-left: 4px; cursor: pointer;"></i>
                </el-tooltip>
              </div>
            </div>
          </el-col>

          <el-col :span="10" class="upload-col">
             <div class="upload-wrapper">
                <div class="upload-title-red">必选</div>
                <div class="upload-card">
                   <el-upload
                      v-show="leaseContractFiles.length === 0"
                      class="custom-uploader"
                      :action="actionUrl"
                      :headers="uploadHeaders"
                      :data="{ group: 'order', code: 'order_contract_attachment_file' }"
                      :show-file-list="false"
                      accept=".pdf"
                      :before-upload="beforePdfUpload"
                      :on-success="handleLeaseContractSuccess"
                      :on-error="handleUploadError"
                    >
                       <div class="upload-placeholder">
                          <i class="el-icon-picture-outline"></i>
                          <i class="el-icon-plus plus-icon"></i>
                          <span>点击添加本地文件</span>
                       </div>
                    </el-upload>

                   <div class="upload-preview" v-if="leaseContractFiles.length > 0">
                        <div class="pdf-icon-wrapper">
                            <i class="el-icon-document"></i>
                        </div>
                        <div class="card-actions">
                            <span class="action-btn" @click="previewPdf(leaseContractFiles[0].url)">预览</span>
                            <span class="action-btn" @click="handleLeaseContractRemove">移除</span>
                        </div>
                   </div>
                </div>
                <div class="upload-label">
                  租赁合同 (PDF)
                  <el-tooltip class="item" effect="dark" placement="top">
                    <div slot="content">
                      1、租赁合同取自线上签约或租赁订单上传的合同.<br/>
                      2、如果大小超过1M,或者在线使用失败的情况,可以点击后上传本地合同.
                    </div>
                    <i class="el-icon-question" style="color: #999; margin-left: 4px; cursor: pointer;"></i>
                  </el-tooltip>
                </div>
                <div class="online-contract-link">
                   <el-link type="primary" :underline="true" @click="useOnlineContract">使用在线合同</el-link>
                </div>
             </div>
          </el-col>

          <el-col :span="10" class="upload-col">
             <div class="upload-wrapper">
                <div class="upload-title">非必选</div>
                <div class="upload-card" @click="handleOtherFileClick">
                   <el-upload
                      v-show="otherFile.length === 0"
                      class="custom-uploader"
                      :action="actionUrl"
                      :headers="uploadHeaders"
                      :data="{ group: 'order', code: 'order_contract_attachment_file' }"
                      :show-file-list="false"
                      accept="image/jpeg,.jpg,.jpeg"
                      :before-upload="beforeImageUpload"
                      :on-success="handleOtherUploadSuccess"
                      :on-error="handleUploadError"
                      :disabled="writtenApplicationFiles.length === 0"
                    >
                       <div class="upload-placeholder">
                          <i class="el-icon-picture-outline"></i>
                          <i class="el-icon-plus plus-icon"></i>
                          <span>点击添加本地文件</span>
                       </div>
                    </el-upload>

                   <div class="upload-preview" v-if="otherFile.length > 0">
                        <img :src="otherFile[0].url" class="preview-image" />
                        <div class="card-actions">
                            <span class="action-btn" @click="previewImage(otherFile[0].url)">预览</span>
                            <span class="action-btn" @click="handleOtherFileRemove">移除</span>
                        </div>
                   </div>
                </div>
                <div class="upload-label">
                  其他补充 (JPG/JPEG)
                  <el-tooltip class="item" effect="dark" content="补充材料会自动与书面申请进行合并. 请先添加书面申请,然后再添加补充资料." placement="top">
                    <i class="el-icon-question" style="color: #999; margin-left: 4px; cursor: pointer;"></i>
                  </el-tooltip>
                </div>
                <div class="online-contract-link">
                  <el-link type="primary" :underline="true" @click="copySmsContent">复制短信内容</el-link>
                  <el-tooltip class="item" effect="dark" content="短信需要自行发送给司机, 具体短信内容依据实际情况,进行调整." placement="top">
                    <i class="el-icon-question" style="color: #999; margin-left: 4px; cursor: pointer;"></i>
                  </el-tooltip>
                </div>
             </div>
          </el-col>
        </el-row>
      </div>

      <div class="form-section">
        <el-form :model="form" ref="formRef" label-width="0">
           <div class="company-name-group">
             <div class="input-label">转移申请/关系证明盖章公司名称</div>
             <div class="input-row">
                 <div class="input-wrapper">
                     <el-form-item prop="companyName" :rules="[{ required: true, message: '请输入公司名称', trigger: 'blur' }]" class="custom-input-item">
                       <el-input v-model="form.companyName" placeholder="" class="no-border-input" disabled></el-input>
                     </el-form-item>
                 </div>
             </div>
           </div>

           <div class="phone-group">
             <div class="input-label">租赁公司联系方式</div>
             <div class="input-row">
                 <div class="input-wrapper">
                     <el-form-item prop="transferContractPhone" :rules="[{ required: true, message: '请输入手机号', trigger: 'blur' }, { validator: validateMobile, trigger: 'blur' }]" class="custom-input-item">
                       <el-input v-model="form.transferContractPhone" placeholder="请输入手机号" class="no-border-input"></el-input>
                     </el-form-item>
                 </div>
             </div>
           </div>
        </el-form>
      </div>

      <div class="bottom-links">
         <el-link type="primary" :underline="true" class="electronic-sign-link" @click="useElectronicSeal" style="margin-right: 30px;">使用电子签章</el-link>
         <el-link type="primary" :underline="true" @click="downloadWrittenApplication">下载书面申请(线下盖章后上传)</el-link>
      </div>

      <div class="tips-section">
        <div class="tips-title">温馨提示</div>
        <div class="tips-content">
          1、书面申请及租赁合同的单位盖章需与备案单位名称一致，请确认后提交；<br>
          2、书面申请支持类型为JPG、JPEG,文件大小不超过1M；<br>
          3、租赁合同影印件必须为PDF格式,文件大小不超过1M。
        </div>
      </div>
    </div>

    <template slot="footer">
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span style="color: #F56C6C; font-size: 12px;">首次转移, 先群内联系,进行操作讲解.</span>
        <div>
          <el-button type="primary" :loading="submitLoading" @click="handleSubmit">提交申请</el-button>
          <el-button @click="handleClose">取消</el-button>
        </div>
      </div>
    </template>
  </dialogWrap>
</template>

<script setup>
import { ref, computed, onUnmounted, getCurrentInstance } from 'vue'
import { Message, MessageBox, Loading } from 'element-ui'
import { useSubmitLock } from '@/utils/useUtils'
import { interfacePrefix } from '@/config'
import { getHead, downFileByUrl } from '@/utils'
import store from '@/store'
import { violationTransferApply,
  checkTransferSignFile,
  querySignatureResult,
  getViolationTransferFile,
  getContractTransferInfo,
  getSmsInfo,
} from '@/api/domain/carsService'

import { uploadFile } from '@/api/domain/vehicle'
import { validateMobile } from '@/utils/validate'

const { proxy } = getCurrentInstance()

const emits = defineEmits(['open'])

const visible = ref(false)
const writtenApplicationFiles = ref([])
const leaseContractFiles = ref([])
const otherFile = ref([])
const dialogContentRef = ref(null)
const writtenApplicationCardRef = ref(null)
const companyCode = ref('')
let writtenApplicationLoadingInstance = null

const form = ref({
  companyName: '',
  contractNo: '',
  contractId: '',
  transferContractPhone: '',
})

const actionUrl = `${interfacePrefix}/fs/standard/upload`
const formRef = ref(null)
const pollTimer = ref(null)

const { loading: submitLoading, run } = useSubmitLock()

const uploadHeaders = computed(() => getHead(store))

const fileTypeEnum = {
  ELECTRONIC_SEAL: 10, // 使用电子签章
  OFFLINE_TEMPLATE: 20, // 下载书面申请模板线下盖章
  ONLINE_CONTRACT: 30, // 使用在线合同
}

const clearTimer = () => {
  if (pollTimer.value) {
    clearInterval(pollTimer.value)
    pollTimer.value = null
  }
  if (writtenApplicationLoadingInstance) {
    writtenApplicationLoadingInstance.close()
    writtenApplicationLoadingInstance = null
  }
}

const reset = () => {
  writtenApplicationFiles.value = []
  leaseContractFiles.value = []
  otherFile.value = []
  originalWrittenApplicationUrl.value = ''
  form.value.companyName = ''
  form.value.transferContractPhone = ''
  if (formRef.value) {
    formRef.value.clearValidate()
  }
  clearTimer()
}

const show = (row) => {
  visible.value = true
  form.value.contractNo = row.contractNo
  reset()
  getInfo(row)
}

const getInfo = async (row) => {
  const { code, data } = await getContractTransferInfo({
    contractNo: row.contractNo,
    contractId: row.contractId,
  })

  if (code === 1) {
    form.value.companyName = data.companyName || ''
    form.value.transferContractPhone = data.transferContractPhone || ''
    form.value.contractId = data.contractId || row.contractId || ''
    companyCode.value = data.companyCode
    if (data.transferApplyFile) {
      writtenApplicationFiles.value = [{
        name: '书面申请.jpg',
        url: data.transferApplyFile,
      }]
    }
    if (data.transferContractFile) {
      leaseContractFiles.value = [{
        name: '租赁合同.pdf',
        url: data.transferContractFile,
      }]
    }
  }
}

const handleClose = () => {
  visible.value = false
  clearTimer()
}

onUnmounted(() => {
  clearTimer()
})

const beforeImageUpload = (file) => {
  const isJPG = file.type === 'image/jpeg' || file.type === 'image/jpg'
  const isLt1M = file.size / 1024 / 1024 < 1

  if (!isJPG) {
    Message.error('书面申请仅支持 JPG, JPEG 格式!')
  }
  if (!isLt1M) {
    Message.error('书面申请大小不能超过 1MB!')
  }
  return isJPG && isLt1M
}

const beforePdfUpload = (file) => {
  const isPDF = file.type === 'application/pdf'
  const isLt1M = file.size / 1024 / 1024 < 1

  if (!isPDF) {
    Message.error('租赁合同仅支持 PDF 格式!')
  }
  if (!isLt1M) {
    Message.error('租赁合同大小不能超过 1MB!')
  }
  return isPDF && isLt1M
}

const handleWrittenApplicationSuccess = (res, file) => {
  if (res && res.code === 1) {
    writtenApplicationFiles.value = [{
      name: res.data.fileName || file.name,
      url: res.data.url || res.data,
    }]
  } else {
    Message.error(res.msg || '上传失败')
    writtenApplicationFiles.value = []
  }
}

const handleWrittenApplicationRemove = () => {
  MessageBox.confirm('确定要移除书面申请吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    writtenApplicationFiles.value = []
    otherFile.value = []
    Message.success('移除成功')
  }).catch(() => {
    // cancelled
  })
}

const handleLeaseContractSuccess = (res, file) => {
  if (res && res.code === 1) {
    leaseContractFiles.value = [{
      name: res.data.fileName || file.name,
      url: res.data.url || res.data,
    }]
  } else {
    Message.error(res.msg || '上传失败')
    leaseContractFiles.value = []
  }
}

const handleLeaseContractRemove = () => {
  MessageBox.confirm('确定要移除租赁合同吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    leaseContractFiles.value = []
    Message.success('移除成功')
  }).catch(() => {
    // cancelled
  })
}


const originalWrittenApplicationUrl = ref('')

const handleOtherFileRemove = () => {
  MessageBox.confirm('确定要移除其他文件吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    otherFile.value = []
    if (writtenApplicationFiles.value.length > 0 && originalWrittenApplicationUrl.value) {
      writtenApplicationFiles.value = [{
        name: '书面申请.jpg',
        url: originalWrittenApplicationUrl.value,
      }]
    }
    originalWrittenApplicationUrl.value = ''
    Message.success('移除成功')
  }).catch(() => {
    // cancelled
  })
}

const handleOtherFileClick = (e) => {
  if (e.target.closest('.action-btn')) return
  if (writtenApplicationFiles.value.length === 0) {
    Message.error('请先上传书面申请文件')
  }
}


const handleOtherUploadSuccess = async (res, file) => {
  if (res && res.code === 1) {
    const newImageUrl = res.data

    otherFile.value = [{
      name: file.name,
      url: res.data,
    }]

    if (writtenApplicationFiles.value.length > 0 && writtenApplicationFiles.value[0].url) {
      if (!originalWrittenApplicationUrl.value) {
        originalWrittenApplicationUrl.value = writtenApplicationFiles.value[0].url
      }
      const originalImageUrl = originalWrittenApplicationUrl.value

      const loadingInstance = Loading.service({
        target: dialogContentRef.value,
        lock: true,
        text: '正在合并图片中',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)',
      })

      try {
        const mergedFile = await mergeAndCompressImages(originalImageUrl, newImageUrl)

        const formData = new FormData()
        formData.append('file', mergedFile, 'merged_application.jpg')
        formData.append('group', 'order')
        formData.append('code', 'order_contract_attachment_file')

        const { code, data, msg } = await uploadFile(formData)
        if (code === 1) {
          writtenApplicationFiles.value = [{
            name: '书面申请-合并.jpg',
            url: data,
          }]
          Message.success('图片合并并上传成功')
        } else {
          Message.error(msg || '合并图片上传失败')
        }
      } catch (e) {
        console.error(e)
        Message.error('图片处理失败')
      } finally {
        loadingInstance.close()
      }
    } else {
      Message.error('请先上传书面申请')
    }
  } else {
    Message.error(res.msg || '上传失败')
  }
}

const mergeAndCompressImages = (url1, url2) => {
  return new Promise((resolve, reject) => {
    const img1 = new Image()
    const img2 = new Image()
    img1.crossOrigin = 'Anonymous'
    img2.crossOrigin = 'Anonymous'

    let loadedCount = 0
    const checkLoaded = () => {
      loadedCount++
      if (loadedCount === 2) {
        draw()
      }
    }

    img1.onload = checkLoaded
    img2.onload = checkLoaded
    img1.onerror = (e) => reject(e)
    img2.onerror = (e) => reject(e)

    img1.src = url1
    img2.src = url2

    const draw = () => {
      const width = Math.max(img1.width, img2.width)
      const height = img1.height + img2.height
      const canvas = document.createElement('canvas')
      canvas.width = width
      canvas.height = height
      const ctx = canvas.getContext('2d')

      ctx.fillStyle = '#fff'
      ctx.fillRect(0, 0, width, height)

      ctx.drawImage(img1, 0, 0)
      ctx.drawImage(img2, 0, img1.height)

      compress(canvas, 0.9)
    }

    const compress = (canvas, quality) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error('Canvas toBlob failed'))
          return
        }
        if (blob.size > 1024 * 1024 && quality > 0.1) {
          compress(canvas, quality - 0.1)
        } else {
          resolve(blob)
        }
      }, 'image/jpeg', quality)
    }
  })
}

const handleUploadError = (err) => {
  Message.error('上传失败，请重试')
  console.error(err)
}

const copySmsContent = async () => {
  const { code, data } = await getSmsInfo({
    contractNo: form.value.contractNo,
    contractId: form.value.contractId,
  })
  if (code === 1) {
    proxy.$copyText(data.smsContent).then(() => {
      Message.success('复制成功')
    }).catch(() => {
      Message.error('复制失败')
    })
  }
}

const handleSubmit = () => {
  formRef.value.validate((valid) => {
    if (!valid) return
    run(async () => {
      if (writtenApplicationFiles.value.length === 0) {
        Message.warning('请上传书面申请')
        return
      }
      if (leaseContractFiles.value.length === 0) {
        Message.warning('请上传租赁合同')
        return
      }

      const { code } = await violationTransferApply({
        contractNo: form.value.contractNo,
        contractId: form.value.contractId,
        transferApplyFile: writtenApplicationFiles.value[0].url,
        transferContractFile: leaseContractFiles.value[0].url,
        transferContractPhone: form.value.transferContractPhone,
      })

      if (code === 1) {
        handleClose()
        emits('open', {
          contractNo: form.value.contractNo,
          companyCode: companyCode.value,
        })
      }
    })
  })
}

const downloadWrittenApplication = async () => {
  formRef.value.validate(async (valid) => {
    if (valid) {
      const { code, data } = await getViolationTransferFile({
        contractNo: form.value.contractNo,
        contractId: form.value.contractId,
        transferContractPhone: form.value.transferContractPhone,
        fileType: fileTypeEnum.OFFLINE_TEMPLATE,
      })
      if (code === 1) {
        Message.success('下载文件成功')
        downFileByUrl(data.transferApplyFile)
      }
    }
  })
}

const previewImage = (url) => {
  window.open(url, '_blank')
}

const previewPdf = (url) => {
  window.open(url, '_blank')
}

const useOnlineContract = async () => {
  const { code, data } = await getViolationTransferFile({
    contractNo: form.value.contractNo,
    contractId: form.value.contractId,
    fileType: fileTypeEnum.ONLINE_CONTRACT,
  })
  if (code === 1) {
    leaseContractFiles.value = [{
      name: '合同.pdf',
      url: data.transferContractFile,
    }]
    Message.success('已使用线上合同')
  }
}

const useElectronicSeal = async () => {
  formRef.value.validate(async (valid) => {
    if (valid) {
      try {
        const { code, data } = await checkTransferSignFile({
          contractNo: form.value.contractNo,
          contractId: form.value.contractId,
          transferContractPhone: form.value.transferContractPhone,
        })
        if (code === 1 && data) {
          MessageBox.confirm(`
               <div style="text-align: center;">
                 <div style="
                    width: 100px;
                    height: 100px;
                    margin: 0 auto 15px;
                  ">
                    <img src="${data.sealImage}" style="width: 100%; height: 100%; object-fit: contain;" />
                  </div>
                  <div style="color: #606266;">请确认使用公司的电子签章,本次使用将会消耗一份易签宝份额</div>
               </div>
             `, '', {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center: true,
          }).then(async () => {
            Message.success('正在生成电子签章文件，请稍等')
            const { code: violationCode } = await getViolationTransferFile({
              contractNo: form.value.contractNo,
              contractId: form.value.contractId,
              transferContractPhone: form.value.transferContractPhone,
              fileType: fileTypeEnum.ELECTRONIC_SEAL,
            })
            if (violationCode === 1) {
              clearTimer()
              writtenApplicationLoadingInstance = Loading.service({
                target: writtenApplicationCardRef.value,
                lock: true,
                text: '正在签署中...',
                spinner: 'el-icon-loading',
                background: 'rgba(255, 255, 255, 0.7)',
              })
              pollTimer.value = setInterval(async () => {
                try {
                  const res = await querySignatureResult({
                    contractNo: form.value.contractNo,
                    contractId: form.value.contractId,
                  })
                  if (res && res.code === 1 && res.data && res.data.transferApplyFile) {
                    writtenApplicationFiles.value = [{
                      name: '电子签章申请书.jpg',
                      url: res.data.transferApplyFile,
                    }]
                    Message.success('电子签章完成，已自动回填')
                    clearTimer()
                  }
                } catch (error) {
                  console.error('Polling error:', error)
                }
              }, 5000)
            }
          }).catch(() => null)
        }
      } catch (error) {
        if (error && error.msg) {
          MessageBox.alert(error.msg, '', {
            type: 'info',
            confirmButtonText: '确定',
            showClose: false,
          })
        }
      }
    }
  })
}

defineExpose({
  show,
})
</script>

<style lang="scss">
.transfer-loading-mask {
  .el-loading-spinner {
    .el-loading-text {
      color: #fff !important;
      font-size: 14px;
      margin-top: 10px;
    }
    .el-icon-loading {
      color: #fff !important;
      font-size: 30px;
    }
  }
}
</style>
<style lang="scss" scoped>
.transfer-dialog-content {
  padding: 10px 40px;
  position: relative;
}
.upload-section {
  margin-bottom: 20px;
}
.upload-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.upload-card {
    width: 148px;
    height: 148px;
    background-color: #f5f7fa;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    overflow: hidden;

    &:hover {
        border-color: #409EFF;
    }
}
.custom-uploader {
    width: 100%;
    height: 100%;

    ::v-deep .el-upload {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
}
.upload-placeholder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    color: #8c939d;

    .el-icon-picture-outline {
        font-size: 28px;
        margin-bottom: 8px;
    }
    .plus-icon {
        display: none;
    }
    span {
        font-size: 12px;
        line-height: 1.2;
    }
}

.upload-preview {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.preview-image {
    width: 100%;
    height: 0;
    flex: 1;
    object-fit: cover;
}
.pdf-icon-wrapper {
    width: 100%;
    height: 0;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 60px;
    color: #909399;
}

.card-actions {
    position: relative;
    width: 100%;
    height: 32px;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: space-around;
    align-items: center;
    z-index: 100;
}

.action-btn {
    font-size: 14px;
    cursor: pointer;
    color: #fff;

    &:hover {
        color: #409EFF;
    }
}

.upload-label {
    font-size: 14px;
    font-weight: bold;
    color: #606266;
    margin-top: 5px;
}
.online-contract-link {
    margin-top: 15px;
}

.form-section {
    margin-top: 30px;
}
.company-name-group {
    margin-bottom: 20px;
}
.input-label {
    font-size: 16px;
    color: #333;
    margin-bottom: 8px;
    font-weight: 500;
}
.input-row {
    display: flex;
    align-items: flex-end;
}
.input-wrapper {
    flex: 1;
    max-width: 400px;
}
.link-wrapper {
    margin-left: 20px;
    padding-bottom: 10px; /* Align with input text */
}

.custom-input-item {
    margin-bottom: 0;
}

::v-deep .no-border-input .el-input__inner {
    border: none;
    border-bottom: 1px dashed #3333334f;
    border-radius: 0;
    padding-left: 0;
    background: transparent;
    height: 32px;
    line-height: 32px;
}
::v-deep .el-form-item__error {
    padding-top: 5px;
}

.bottom-links {
    margin-top: 40px;
    display: flex;
    justify-content: flex-start;
}

.tips-section {
    margin-top: 30px;
    padding: 10px 0;
}
.tips-title {
    font-weight: bold;
    margin-bottom: 8px;
    font-size: 14px;
}
.tips-content {
    font-size: 12px;
    color: #909399;
    line-height: 20px;
}
.upload-title-red {
  width: 148px;
  font-weight: bold;
  font-size: 16px;
  color: red;
  margin-bottom: 10px;
}
.upload-title {
  width: 148px;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
}
</style>
